/* Esteira Metodológica — barra horizontal com 8 etapas (V2 LSC/EGN). */
import { ESTEIRA_ETAPAS, ESTEIRA_STATUS } from "@/lib/constants";
import { Check, CircleDashed, Clock, MinusCircle } from "lucide-react";

const ICONS = {
  nao_iniciado: CircleDashed,
  em_andamento: Clock,
  concluido: Check,
  nao_aplicavel: MinusCircle,
};

export default function EsteiraMetodologica({ value = {}, onChange, compact = false }) {
  const cycle = (cur) => {
    const order = ["nao_iniciado", "em_andamento", "concluido", "nao_aplicavel"];
    return order[(order.indexOf(cur || "nao_iniciado") + 1) % order.length];
  };
  return (
    <div className="card-mil p-3 gold-accent-top" data-testid="esteira-metodologica">
      <div className="flex items-center justify-between gap-2 mb-2 flex-wrap">
        <div className="label-mil text-[var(--gold)]">Esteira Metodológica</div>
        <span className="text-[10px] text-[var(--text-muted)]">Clique numa etapa para alternar status</span>
      </div>
      <div className={`grid ${compact ? "grid-cols-4 md:grid-cols-8" : "grid-cols-2 md:grid-cols-4 lg:grid-cols-8"} gap-1`}>
        {ESTEIRA_ETAPAS.map((etapa, idx) => {
          const st = value[etapa.key] || "nao_iniciado";
          const meta = ESTEIRA_STATUS[st] || ESTEIRA_STATUS.nao_iniciado;
          const Icon = ICONS[st] || CircleDashed;
          const isLast = idx === ESTEIRA_ETAPAS.length - 1;
          return (
            <button
              key={etapa.key}
              type="button"
              onClick={() => onChange && onChange({ ...value, [etapa.key]: cycle(st) })}
              className="relative text-left border border-[var(--border)] rounded p-2 hover:bg-[var(--surface-2)] transition"
              style={{ borderColor: st === "nao_iniciado" ? undefined : meta.color }}
              data-testid={`esteira-step-${etapa.key}`}
            >
              <div className="flex items-center gap-1.5">
                <Icon size={12} style={{ color: meta.color }} />
                <span className="text-[10px] font-mono text-[var(--text-muted)]">{idx + 1}/8</span>
              </div>
              <div className="text-[11px] font-bold mt-1 leading-tight" style={{ color: meta.color }}>{etapa.label}</div>
              <div className="text-[9px] text-[var(--text-muted)] uppercase mt-0.5">{meta.label}</div>
              {!isLast && <div className="hidden lg:block absolute right-[-2px] top-1/2 w-[3px] h-[3px] bg-[var(--border)] rounded-full" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
